import { render, staticRenderFns } from "./View.vue?vue&type=template&id=a94cad30&scoped=true&lang=html&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94cad30",
  null
  
)

export default component.exports